import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Avatar, Typography } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 'fit-content'
  },
  avatar: {
    width: 60,
    height: 60
  },
  name: {
    marginTop: '4px'
  }
}));

const Profile = props => {
  const { user, className, ...rest } = props;

  const classes = useStyles();
 

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Avatar
        alt="Person"
        className={classes.avatar}
        component={RouterLink}
        src={user && user.avatar ? user.avatar : '//filmschoolrejects.com/wp-content/uploads/2017/04/0lZC6SveOnYzvS6Nl.jpg'}
        to="/account"
      />
      <Typography
        className={classes.name}
        variant="h4"
      >
        {user ? user.username : 'unknown'}
      </Typography> 
    </div>
  );
};

Profile.propTypes = {
  className: PropTypes.string,
  user: PropTypes.object
};

export default Profile;
